import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: "https://auth.circuito.net/",
    "auth-server-url": "https://auth.circuito.net/",
    realm: "master",
    clientId: "newsdesk-nd"
});

window.Circuito = keycloak;

export default keycloak;